import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import './Tutorial.scss';

import data from './dataTutoEnglish';

const KevinD = function KevinD() {
  const { slug, page } = useParams();
  const navigate = useNavigate();

  const [openSelect, setOpenSelect] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const currentPage = parseInt(page, 10);

  // Get 1 tutorial with params
  const tutorial = data.find((tuto) => tuto.slug === slug);
  const maxPage = tutorial.steps.length;

  // Check if exist or within page, else return to pres
  if (!tutorial || currentPage < 1 || maxPage < currentPage) {
    return <Navigate to={`/allamano/${tutorial.slug}`} />;
  }

  // handle page change
  const changePage = (pageNb) => {
    navigate(`/allamano/${tutorial.slug}/${pageNb}`);
  };

  // open/close select
  const toggleSelect = () => {
    setOpenSelect(!openSelect);
  };

  // select with select
  const chooseSelect = (num) => {
    toggleSelect();
    changePage(num);
  };

  // next page
  const nextPage = () => {
    let npage = currentPage + 1;
    if (npage >= maxPage) npage = maxPage;
    changePage(npage);
  };

  // prev page
  const prevPage = () => {
    let ppage = currentPage - 1;
    if (ppage <= 0) ppage = 0;
    changePage(ppage);
  };

  const select = useRef();
  const progressBar = useRef();

  // close select on click not in element
  useEffect(() => {
    if (!select) return;
    document.addEventListener('click', (event) => {
      const selectClickInside = select.current.contains(event.target);
      if (!selectClickInside && openSelect) {
        setOpenSelect(false);
      }
    });
  }, [select, openSelect]);

  // progress bar
  useEffect(() => {
    if (!progressBar) return;
    progressBar.current.style.width = `${Math.min(
      Math.ceil((100 / maxPage) * currentPage),
      100
    )}%`;
  }, [currentPage, maxPage]);

  return (
    <section className="tutorial">
      <a className="back-button" href="/allamano">
        <svg
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          viewBox="0 0 212.982 212.982"
          xmlSpace="preserve"
        >
          <g id="Close">
            <path
              d="M131.804,106.491l75.936-75.936c6.99-6.99,6.99-18.323,0-25.312
		c-6.99-6.99-18.322-6.99-25.312,0l-75.937,75.937L30.554,5.242c-6.99-6.99-18.322-6.99-25.312,0c-6.989,6.99-6.989,18.323,0,25.312
		l75.937,75.936L5.242,182.427c-6.989,6.99-6.989,18.323,0,25.312c6.99,6.99,18.322,6.99,25.312,0l75.937-75.937l75.937,75.937
		c6.989,6.99,18.322,6.99,25.312,0c6.99-6.99,6.99-18.322,0-25.312L131.804,106.491z"
            />
          </g>
        </svg>
        <span>Back to tutorials list</span>
      </a>

      <div className="tutorial-progress-bar">
        <div className="progress-bar">
          <div className="offset-bar" ref={progressBar} />
        </div>
      </div>

      <h1 className="tutorial-name">
        <span className="arrow">➜ </span>
        <span>{tutorial.nomTuto}</span>
      </h1>

      <hr />

      <div className="tutorial-step" ref={select}>
        <div className="tutorial-page-list">
          <button
            className="selected"
            type="button"
            onClick={() => toggleSelect()}
          >
            <span>Step {currentPage}</span>
            <span className={`arrow-bottom ${openSelect ? 'hidden' : ''}`}>
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  id="Iconly/Bold/Arrow---Down-2"
                  stroke="none"
                  strokeWidth="1"
                  fillRule="evenodd"
                  transform="translate(6.000000, 7.000000)"
                >
                  <path d="M4.869,9.63078422 C4.811,9.57428154 4.563,9.36093522 4.359,9.16220166 C3.076,7.99707745 0.976,4.95762299 0.335,3.36678032 C0.232,3.12518266 0.014,2.51436922 0,2.18801754 C0,1.87530443 0.072,1.57720409 0.218,1.29274233 C0.422,0.938139308 0.743,0.653677545 1.122,0.497808086 C1.385,0.397467121 2.172,0.241597662 2.186,0.241597662 C3.047,0.0857282026 4.446,0 5.992,0 C7.465,0 8.807,0.0857282026 9.681,0.213346322 C9.695,0.227959084 10.673,0.383828544 11.008,0.554310765 C11.62,0.867023868 12,1.47783731 12,2.13151486 L12,2.18801754 C11.985,2.613736 11.605,3.5090112 11.591,3.5090112 C10.949,5.01412567 8.952,7.98343887 7.625,9.17681442 C7.625,9.17681442 7.284,9.51290794 7.071,9.65903556 C6.765,9.88699464 6.386,10 6.007,10 C5.584,10 5.19,9.87238188 4.869,9.63078422" />
                </g>
              </svg>
            </span>
            <span className={`arrow-up ${openSelect ? '' : 'hidden'}`}>
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  id="Iconly/Bold/Arrow---Down-2"
                  stroke="none"
                  strokeWidth="1"
                  fillRule="evenodd"
                  transform="translate(6.000000, 7.000000)"
                >
                  <path d="M7.131,0.369215782 C7.189,0.425718461 7.437,0.639064783 7.641,0.837798344 C8.924,2.00292255 11.024,5.04237701 11.665,6.63321968 C11.768,6.87481734 11.986,7.48563078 12,7.81198246 C12,8.12469557 11.928,8.42279591 11.782,8.70725767 C11.578,9.06186069 11.257,9.34632245 10.878,9.50219191 C10.615,9.60253288 9.828,9.75840234 9.814,9.75840234 C8.953,9.9142718 7.554,10 6.008,10 C4.535,10 3.193,9.9142718 2.319,9.78665368 C2.305,9.77204092 1.327,9.61617146 0.992,9.44568924 C0.38,9.13297613 0,8.52216269 0,7.86848514 L0,7.81198246 C0.015,7.386264 0.395,6.4909888 0.409,6.4909888 C1.051,4.98587433 3.048,2.01656113 4.375,0.823185582 C4.375,0.823185582 4.716,0.48709206 4.929,0.340964442 C5.235,0.113005358 5.614,0 5.993,0 C6.416,0 6.81,0.12761812 7.131,0.369215782" />
                </g>
              </svg>
            </span>
          </button>

          <div className={`page-list ${openSelect ? '' : 'hidden'}`}>
            {tutorial.steps.map((stepPage, pageIndex) => (
              <div key={stepPage.etape}>
                <button
                  onClick={() => chooseSelect(pageIndex + 1)}
                  type="button"
                  className="page"
                >
                  Step {pageIndex + 1}
                </button>
                {pageIndex + 1 < maxPage && <span className="separator" />}
              </div>
            ))}
          </div>
        </div>

        <h2 className="tutorial-title">Step {currentPage}</h2>
      </div>

      <div className="tutorial-buttons">
        {currentPage > 1 && (
          <button
            className="left-button"
            type="button"
            onClick={() => prevPage()}
          >
            Previous
          </button>
        )}
        {currentPage < maxPage && (
          <button
            className="right-button"
            type="button"
            onClick={() => nextPage()}
          >
            Next
          </button>
        )}
      </div>

      <div className="tutorial-presentation">
        <div
          className={`step-description ${
            !tutorial.steps[currentPage - 1].image ? 'full-width' : ''
          }`}
        >
          {tutorial.steps[currentPage - 1].etape}
        </div>
        {tutorial.steps[currentPage - 1].image && (
          <button
            className="step-image-container"
            onClick={() => setIsOpen(true)}
            type="button"
          >
            <img
              src={tutorial.steps[currentPage - 1].image}
              alt={tutorial.steps[currentPage - 1].etape}
              className="step-image"
            />
          </button>
        )}
      </div>

      {isOpen && (
        <Lightbox
          mainSrc={tutorial.steps[currentPage - 1].image}
          onCloseRequest={() => setIsOpen(false)}
        />
      )}
    </section>
  );
};

export default KevinD;
